// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ModalHeader_imageWrapper__r-urO","image":"ModalHeader_image__fu2ZE"};